import { render } from "./ConsulteGrid.vue?vue&type=template&id=215f3296&ts=true"
import script from "./ConsulteGrid.vue?vue&type=script&lang=ts"
export * from "./ConsulteGrid.vue?vue&type=script&lang=ts"

import "./ConsulteGrid.vue?vue&type=style&index=0&id=215f3296&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__